const Images = {
  logo: require("./images/logo.png"),
  loginImage: require("./images/cimage.jpg"),
  homeTitle: require("./images/HomeTitle.png"),
  capsule: require("./images/capsules.png"),
  heart: require("./images/heart.png"),
  user: require("./images/user_avatar.png"),
  dUser: require("./images/dUser.jpg"),
  banner: require("./images/banner.png"),
  navImg: require("./images/navImg.png"),
  google: require("./images/google.png"),
  iphone: require("./images/iphone.png"),
  prescript: require("./images/prescript.png"),
  map: require("./images/map.png"),
}

export default Images;